import { render, staticRenderFns } from "./MaterialPriceList.vue?vue&type=template&id=fc31dde4&"
import script from "./MaterialPriceList.vue?vue&type=script&lang=js&"
export * from "./MaterialPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports